import createRoute                  from '@widesk-ui/tools/createRoute';
import StonecodeMailEditorMailModel from '@models/website/StonecodeMailEditorMailModel';

const route = createRoute.dashboard(
	'/configuration/mails',
	'website',
	'MailDashboard',
	StonecodeMailEditorMailModel.localize(),
);
export default route;
